import { Form } from '@kanda-libs/ks-component-ts';
import { Button, Loader, Text } from '@kanda-libs/ks-design-library';

import OpenBankingSatNoteFormInitialNotice from './InitialNotice';
import SatNoteFormQuestions from './Questions';
import SatNoteFormTerms from './Terms';
import useOpenBankingSatNoteForm from './useOpenBankingSatNoteForm';

import { FORM_ID } from '../../constants';
import OpenBankingSatNoteFormLoader from '../Loader';

const OpenBankingSatNoteForm: React.FunctionComponent = function () {
  const {
    scrollRef,
    form,
    onSubmit,
    page,
    isLoading,
    isSubmitting,
    nextButtonProps,
  } = useOpenBankingSatNoteForm();
  return (
    <Form id={FORM_ID} form={form} onSubmit={onSubmit}>
      <div ref={scrollRef} className="absolute top-0" />
      <div className="flex-col w-full mb-6">
        {isLoading ? (
          <OpenBankingSatNoteFormLoader />
        ) : (
          <>
            <Text
              className="block text-14-22-em text-lavender-300 mb-2"
              text="Action required"
            />
            <Text
              className="block mb-8 text-2xl text-20-24-em"
              text="Sign satisfaction note"
            />
            {page === 'initial' && <OpenBankingSatNoteFormInitialNotice />}
            {page === 'terms' && <SatNoteFormTerms />}
            {page === 'questions' && <SatNoteFormQuestions />}
            <Button.Text {...nextButtonProps} />
          </>
        )}
      </div>
      <Loader isLoading={isSubmitting} />
    </Form>
  );
};

export default OpenBankingSatNoteForm;
